import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useLayoutEffect } from 'react';
import { View } from 'react-native';
import { ListLoader } from '../../Loader/rn';
var Loading = /*#__PURE__*/React.createElement(View, {
  style: {
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  }
}, /*#__PURE__*/React.createElement(ListLoader, null));
var Delayed = function Delayed(_ref) {
  var children = _ref.children,
    _ref$waitBeforeShow = _ref.waitBeforeShow,
    waitBeforeShow = _ref$waitBeforeShow === void 0 ? 500 : _ref$waitBeforeShow,
    _ref$showLoadingPlace = _ref.showLoadingPlaceholder,
    showLoadingPlaceholder = _ref$showLoadingPlace === void 0 ? true : _ref$showLoadingPlace;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShown = _useState2[0],
    setIsShown = _useState2[1];
  useLayoutEffect(function () {
    var timer = setTimeout(function () {
      setIsShown(true);
    }, waitBeforeShow);
    return function () {
      return clearTimeout(timer);
    };
  }, [waitBeforeShow]);
  return isShown ? children : showLoadingPlaceholder ? Loading : null;
};
export default Delayed;